import { Category } from '@/model/category';
import { Feedback } from '@/model/feedback';
import { OfferType } from '@/model/offer-type';

import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-feedback-details',
  imports: [
    MatCardModule,
    MatIconModule,
    MatDividerModule,
    MatChipsModule
],
  templateUrl: './feedback-details.component.html',
  styleUrl: './feedback-details.component.scss',
  standalone: true,
})
export class FeedbackDetailsComponent implements OnInit {
  @Input() feedback!: Feedback;
  @Input() categories!: Category[];
  @Input() offerTypes!: OfferType[];

  ngOnInit(): void {
    console.log(this.feedback);
  }

  getStatusColor(status: boolean): string {
    return status ? 'text-green-600' : 'text-red-600';
  }

  getStatusIcon(status: boolean): string {
    return status ? 'check_circle' : 'cancel';
  }

  getFinalDecisionColor(decision: string | undefined): string {
    switch (decision) {
      case 'APPROVE':
        return 'text-green-600';
      case 'REJECT':
        return 'text-red-600';
      case 'MODIFY':
        return 'text-orange-600';
      default:
        return 'text-gray-600';
    }
  }

  getFinalDecisionIcon(decision: string | undefined): string {
    switch (decision) {
      case 'APPROVE':
        return 'check_circle';
      case 'REJECT':
        return 'cancel';
      case 'MODIFY':
        return 'edit';
      default:
        return 'help';
    }
  }

  getFinalDecisionText(decision: string | undefined): string {
    switch (decision?.trim()) {
      case 'APPROVE':
        return 'Genehmigt';
      case 'REJECT':
        return 'Abgelehnt';
      case 'REQUEST_MODIFICATION':
        return 'Änderungen angefordert';
      default:
        return 'Keine Entscheidung';
    }
  }

  getNameForCategory(categoryId: string): string {
    const category = this.categories.find((c) => c.id === categoryId);
    return category ? category.name : 'Unbekannt';
  }

  getNameForOfferType(offerTypeId: string): string {
    const offerType = this.offerTypes.find((t) => t.id === offerTypeId);
    return offerType ? offerType.offerName : 'Unbekannt';
  }
}
